export default "__VITE_ASSET__DdycnZM5__"